<template>
  <div class="raised-card">
    <div v-if="title || subtitle || $slots.subtitle" class="mb-4">
      <h5 v-if="title" class="title is-5" v-text="title" />
      <div v-if="subtitle || $slots.subtitle" class="subtitle is-6 has-text-grey-dark">
        <slot name="subtitle">
          {{ subtitle }}
        </slot>
      </div>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'RaisedCard',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.raised-card {
  padding: 1rem;
  background-color:#fff;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);
}
.title.is-5 {
  margin-bottom: 0.5rem;
}
.subtitle.is-6 {
  margin-top: -0.25rem;
}
</style>
